export function getLocalizedText(
  value: string | Record<string, string> | undefined | null,
  locale: string
): string {
  if (!value) return ""
  return typeof value === "string" ? value : value[locale] || ""
}
